var sign = function sign() {
  return Buffer.from('');
};

var verify = function verify(key, payload, signature) {
  return !signature.length;
};

module.exports = function (JWA, JWK) {
  JWA.sign.set('none', sign);
  JWA.verify.set('none', verify);
};